import React from 'react';
import MainContainer from '../../../components/MainContainer';
import SectionMain from './components/SectionMain';
import SectionContent from './components/SectionContent';
import LoadInView from '../../../components/LoadInView';
import {VideoInfoWrapper} from './styled';


const VideoInfoPolicy = () => {
    return (
        <MainContainer>
            <VideoInfoWrapper>
                <SectionMain/>
                <LoadInView>
                    <SectionContent/>
                </LoadInView>
            </VideoInfoWrapper>
        </MainContainer>
    );
};

export default VideoInfoPolicy;
